import React from 'react';
export function BonusStack() {
  const bonuses = [{
    id: 1,
    title: 'Kit Express "Después de la Llamada con Mamá"',
    value: '$25.000',
    subtitle: 'Volvé a tu centro en 10 minutos y cortá la rumiación y la culpa después de hablar con tu madre.',
    bullets: ['Protocolo "Tierra–Agua–Voz" de 10 minutos', '12 guiones de límites listos para usar (texto listo para copiar)', 'Checklist de cierre anti-rumiación', '9 tarjetas imprimibles de soberanía']
  }, {
    id: 2,
    title: 'Workbook "Mapa del Linaje Femenino"',
    value: '$25.000',
    subtitle: 'En 30 minutos vas a ver el patrón que se repite en tu clan… y dónde empieza a cortarse.',
    bullets: ['Plantilla de Genograma Femenino imprimible (3 generaciones)', 'Preguntas de excavación para revelar la raíz del patrón', 'Checklist de "Lealtades Invisibles"', 'Plan de corte en 1 página (acción inmediata)']
  }, {
    id: 3,
    title: 'Checklist "Ritual Seguro en Casa"',
    value: '$20.000',
    subtitle: 'Armá tu espacio ritual de forma simple y contenida para sentirte segura durante todo el proceso.',
    bullets: ['Checklist minimalista de insumos (sin comprar mil cosas)', 'Semáforo emocional para no desbordarte', 'Plantilla de cierre del ritual', 'Guía de integración post-ritual']
  }, {
    id: 4,
    title: 'Pack "Mantras en Tarjetas" (21 frases de sanación)',
    value: '$20.000',
    subtitle: 'Reprogramá tu voz interna con 21 mantras para útero, senos, madre y linaje.',
    bullets: ['21 tarjetas imprimibles divididas en 4 categorías', 'Versión móvil lista para el celular', 'Rutina diaria de 2 minutos', '3 fondos de pantalla premium']
  }];
  return <section className="py-8 px-4 bg-cream" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-10" data-id="element-3">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-4">
            Y eso no es todo. Cuando hoy decidís empezar tu proceso, recibís
            también:
          </h2>
        </div>

        <div className="space-y-6" data-id="element-5">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-white rounded-2xl p-6 shadow-soft border-2 border-soft-rose relative overflow-hidden" data-id="element-6">
              <div className="absolute top-0 right-0 bg-deep-rose text-white px-4 py-1 rounded-bl-2xl font-bold shadow-sm text-sm" data-id="element-7">
                Valor: {bonus.value} — Tuyo GRATIS
              </div>

              <div className="mt-6 md:mt-0" data-id="element-8">
                <h3 className="text-xl font-bold mb-2 flex items-center gap-2" data-id="element-9">
                  <span data-id="element-10">🎁</span> BONO #{bonus.id}: {bonus.title}
                </h3>
                <p className="text-base text-warm-brown font-medium mb-4 italic" data-id="element-11">
                  {bonus.subtitle}
                </p>

                <ul className="space-y-2" data-id="element-12">
                  {bonus.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-13">
                      <span className="text-green-600 mt-0.5 text-sm" data-id="element-14">✅</span>
                      <span className="text-warm-brown-dark text-sm" data-id="element-15">
                        {bullet}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}